<template>
    <div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Transactions</h3>
			<div class="d-flex">
				<router-link class="btn btn-sm pd-x-15 btn-white shadow-sm" :to="{ name: 'transactions.upload' }">
					<i data-feather="upload" class="wd-10 mg-r-5"></i> Upload Transactions
				</router-link>
				<router-link class="btn btn-sm btn-outline-default shadow-sm mg-l-5" :to="{ name: 'transactions.new' }">
					<i data-feather="plus" class="wd-10 mg-r-5"></i> New Transaction
				</router-link>
			</div>
		</div>
        <div class="row">
            <div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="transactions-table" class="table">
                    <thead>
                        <tr>
                            <th class="wd-30p">UUID</th>
							<th class="wd-15p">Date</th>
                            <th class="wd-10p">Type</th>
                            <th class="wd-10p text-right"><span class="mr-4">Units</span></th>
                            <th class="wd-10p text-right"><span class="mr-4">Price</span></th>
							<th class="wd-10p">Status</th>
                            <th class="wd-15p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {
			this.table = $("#transactions-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`
					},
					url: "/api/transactions?datatable=true",
					dataFilter: data => {
						var json = JSON.parse(data);
						return JSON.stringify(json.data);
					}
				},
				responsive: true,
				deferRender: true,
				order: [[0, "asc"]],
				columnDefs: [
					{
						targets: 0,
						render: (data, type, row, meta) => {
							return `<a href="/app/transactions/${row[0]}" class="tx-black">${row[0]}</a>`;
						}
					},
					{
						targets: [2, 5, -1],
						className: "text-center"
					},
					{
						targets: [3, 4],
						className: "text-right tx-semibold"
					},
					{
						targets: 2,
						render: (data, type, row, meta) => {
							return this.transactionType(data);
						}
					},
					{
						targets: 4,
						render: (data, type, row, meta) => {
							return this.$options.filters.toCurrency(data, row[6]);
						}
					},
					{
						targets: 5,
						render: (data, type, row, meta) => {
							return this.transactionStatus(data);
						}
					},
					{
						targets: -1,
						orderable: false,
						data: "id",
						render: (data, type, row, meta) => {
							return `<a href="/app/transactions/${row[0]}" class="btn btn-sm btn-white shadow-sm mr-2"><i data-feather="eye" class="wd-10 mg-r-5"></i> View Details</a>`;
						}
					}
				],
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No transactions available for selected date."
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
				drawCallback: settings => {
					feather.replace();
				}
			});

			$("#transactions-table_filter label").prepend(
				"<input type='text' class='mr-2' data-toggle='datepicker' placeholder='Select date'>"
			);
			$("[data-toggle='datepicker']")
				.datepicker({
					format: "yyyy-mm-dd",
					autoHide: true,
					date: moment().format("YYYY-MM-DD"),
					endDate: moment().format("YYYY-MM-DD")
				})
				.on("pick.datepicker", e => {
					this.filterTransactions();
				});
		},
		data() {
			return {
				table: null
			};
		},
		methods: {
			filterTransactions() {
				const date = $("[data-toggle='datepicker']").datepicker(
					"getDate",
					true
				);

				this.table.ajax
					.url("/api/transactions?datatable&date=" + date)
					.load();
			},
			transactionType(type) {
				const _class = {
					buy: "tx-bold tx-info",
					sell: "tx-bold tx-danger",
					withdraw: "tx-bold tx-warning",
					deposit: "tx-bold tx-success",
					fees: "tx-bold tx-indigo"
				};

				return `<span class="${_class[type.toLowerCase()]}">${type}</span>`;
			},
			transactionStatus(status) {
				const _class = {
					processing: "badge badge-sm badge-dim badge-outline-warning",
					complete: "badge badge-sm badge-dim badge-outline-success"
				};

				return `<span class="${_class[status.toLowerCase()]}">${_.startCase(
					status
				)}</span>`;
			}
		}
	};
</script>
